module.exports = __webpack_public_path__ + "img/document-card-outline.602afb45.svg";